import { Form, Input } from "antd";

import PropTypes from "prop-types";

const AddEzPassTagNumber = ({
    setEzPassTagNumber,
    ezPassTagNumber,
    t,
    isDuplicateEzPassTagNumber,
    setIsDuplicateEzPassTagNumber,
}) => (
    <div>
        <p className="text-md font-medium mb-2 flex items-center gap-1">
            {t("ezPassTagNumber")}
            <span className="text-gray-400 text-sm font-normal">({t("optional-field")})</span>
        </p>
        <Form.Item
            validateStatus={isDuplicateEzPassTagNumber ? "error" : ""}
            help={isDuplicateEzPassTagNumber ? t("duplicateEzTagError") : ""}>
            <Input
                placeholder={t("ezPassTagNumber")}
                value={ezPassTagNumber}
                onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, ''); // Remove all spaces
                    setEzPassTagNumber(value);
                    setIsDuplicateEzPassTagNumber(false);
                }}
            />
        </Form.Item>
    </div>
);

AddEzPassTagNumber.propTypes = {
    ezPassTagNumber: PropTypes.string.isRequired,
    setEzPassTagNumber: PropTypes.func.isRequired,
    isDuplicateEzPassTagNumber: PropTypes.bool.isRequired,
    setIsDuplicateEzPassTagNumber: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default AddEzPassTagNumber;
